import React from "react";
import SelectedCheckIcon from "../SelectedCheckIcon";

const OptionButton = ({ label, value, option, setOption, error }) => {
  return (
    <button
      onClick={() => setOption(value)}
      className="relative w-full rounded-3xl option-button-wrapper"
    >
      {option === value && <SelectedCheckIcon />}
      <div
        className={`
            ${
              option === value
                ? "option-button-selected"
                : "option-button-default"
            }

            ${error && !option ? "option-button-error" : "border-divider"}

        py-5 px-4 common-lable border cursor-pointer rounded-3xl w-full !tracking-normal font-medium`}
      >
        <h2>{label}</h2>
      </div>
    </button>
  );
};

export default OptionButton;
